import { FC, useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { pointsQueryState } from "../../stores";
import { usePointsQuery } from "../../generated/graphql";
import { useParams } from "react-router-dom";


export const LoadPoints: FC = () => {
    useLoadPoints();
    return null;
};

function useLoadPoints() {
    const { group } = useParams();
    const { data, loading } = usePointsQuery({
        skip: !group,
        variables: { group },
    });
    const setValue = useSetRecoilState(pointsQueryState);
    useEffect(() => {
        setValue({ data, loading });
    }, [data, loading, setValue]);
    return null;
};
